import { PicProofEnum } from 'app/types/common';

export interface AllowSizeOption {
    min: number;
    max: number;
    tip: string;
}

export interface AllowUploadItemType {
    accepts: Array<{
        accept: string;
        ext: string[];
        // 文件大小的配置项
        sizeOption?: AllowSizeOption;
    }>;
    allowText: string;
}

export type FileUploaderType =
    | PicProofEnum
    | 'pic_id_card_national' // 国外身份证正面
    | 'pic_id_other_national' // 国外身份证反面
    | 'pic_passport' // 护照
    | 'pic_universe' // 通用上传背景
    | 'pic_common_id_card' // 通用身份证件正面
    | 'pic_common_id_other' // 通用身份证件反面
    | 'common' // 通用的证件类型, 仅支持上传图片, 背景是通用背景
    | 'commonPicAndPDF'; // 新增一个类型, 表示通用的允许上传图片和pdf的证件, 背景是通用背景
